var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 38,
    rx: 4,
    fill: "#00579F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9593 25.4649H20.793L22.7734 13.3467H25.9396L23.9593 25.4649Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4357 13.6429C34.8112 13.3977 33.8206 13.127 32.5958 13.127C29.4689 13.127 27.2669 14.777 27.2534 17.1361C27.2275 18.8766 28.8299 19.8433 30.0285 20.4237C31.2535 21.0167 31.6699 21.4038 31.6699 21.9324C31.6575 22.7442 30.68 23.1184 29.7684 23.1184C28.5043 23.1184 27.8269 22.9255 26.7975 22.4738L26.3806 22.2802L25.9375 25.0005C26.6801 25.3353 28.0484 25.6324 29.4689 25.6454C32.7912 25.6454 34.9542 24.0209 34.9798 21.5069C34.9925 20.1274 34.1463 19.0704 32.322 18.2066C31.2145 17.6522 30.5363 17.2783 30.5363 16.711C30.5493 16.1952 31.11 15.667 32.3601 15.667C33.3895 15.6411 34.1458 15.8859 34.7187 16.131L35.0051 16.2597L35.4357 13.6429Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.645 21.1718C39.9057 20.4757 40.9091 17.7813 40.9091 17.7813C40.896 17.8071 41.1694 17.0722 41.3257 16.6211L41.547 17.6653C41.547 17.6653 42.1466 20.566 42.2768 21.1718C41.782 21.1718 40.2704 21.1718 39.645 21.1718ZM43.5535 13.3467H41.1043C40.349 13.3467 39.7752 13.5657 39.4493 14.3521L34.7461 25.4647H38.0685C38.0685 25.4647 38.6154 23.969 38.733 23.6469C39.0975 23.6469 42.3295 23.6469 42.7984 23.6469C42.8893 24.0724 43.1762 25.4647 43.1762 25.4647H46.1079L43.5535 13.3467V13.3467Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1476 13.3467L15.0466 21.6101L14.7078 19.9342C14.1345 18.0004 12.3365 15.8994 10.3301 14.8547L13.1704 25.452H16.5188L21.4957 13.3467H18.1476V13.3467Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.166 13.3467H7.07165L7.01953 13.5915C10.9935 14.5972 13.6253 17.0212 14.7066 19.9347L13.5992 14.3653C13.4169 13.5914 12.8565 13.3722 12.166 13.3467Z",
    fill: "#FAA61A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.c4eccc5e8b5960356c7361667d3e8b02.svg";
export { ForwardRef as ReactComponent };